
import React from 'react'
import { InfoContainer, InfoWrapper, InfoRow, Column1,TopLine,
  TextWrapper, Heading, Column2, ImgWrap, Img, Column3 } from './ContentElement'
import '../../../App.css'
import { useTranslation } from 'react-i18next'


import img1 from "../../../images/press1.png"
import img2 from "../../../images/press2.jpg"
import img3 from "../../../images/press3.jpg"

function ContentSection({lightBg, imgStart, 
  lightText, id, alt}) {

  const {t} = useTranslation();
  return (
		<>
		<InfoContainer lightBg={lightBg} id={id} className='infoContainer'>
			<InfoWrapper>
        <InfoRow imgStart={imgStart}>
          <Column1>
          <Heading lightText={lightText}>{t("content.headline")}</Heading>
            <TextWrapper>
              <ImgWrap>
              <a href='http://it.chosun.com/site/data/html_dir/2021/06/07/2021060701718.html' target="_blank" rel="noopener noreferrer"> <Img src={img1} alt={alt} /></a>
              </ImgWrap>
              <TopLine><a href="http://it.chosun.com/site/data/html_dir/2021/06/07/2021060701718.html" target="_blank" rel="noopener noreferrer" style={{color:"inherit"}}> {t("content.topLine")}</a></TopLine>			
            </TextWrapper>
          </Column1>
          <Column2>
            <TextWrapper>
              <ImgWrap>
              <a href='http://it.chosun.com/site/data/html_dir/2021/06/25/2021062501674.html' target="_blank" rel="noopener noreferrer"> <Img src={img2} alt={alt} /></a>
              </ImgWrap>
              <TopLine><a href="http://it.chosun.com/site/data/html_dir/2021/06/25/2021062501674.html" style={{color:"inherit"}} target="_blank" rel="noopener noreferrer"> {t("content.topLine3")}</a></TopLine>			
            </TextWrapper>
          </Column2>
          <Column3>
            <TextWrapper>
              <ImgWrap>
              <a href='http://kr.aving.net/news/view.php?articleId=1589432&Branch_ID=kr&rssid=naver&mn_name=news' target="_blank" rel="noopener noreferrer"> <Img src={img3} alt={alt} /></a>
              </ImgWrap>
              <TopLine><a href="http://kr.aving.net/news/view.php?articleId=1589432&Branch_ID=kr&rssid=naver&mn_name=news" style={{color:"inherit"}} target="_blank" rel="noopener noreferrer">{t("content.topLine2")}</a></TopLine>			
            </TextWrapper>
          </Column3>
        </InfoRow>
			</InfoWrapper>
		</InfoContainer>	
		</>
	)
}

export default ContentSection
